module.exports = __webpack_public_path__ + "media/images/vsaasio-logo-7fb5d490519f425b2e43998acfe1c098.png";